import { useEffect, useState } from "react";
// @ts-expect-error pure js
import useRefreshToken from "../../hooks/use-refresh-token";
import { Outlet } from "react-router-dom";
// @ts-expect-error pure js
import IsLoading from "../UI/IsLoading";
// @ts-expect-error pure js
import useAuth from "../../hooks/use-auth.js";

export default function PersistLogin() {
  const [isLoading, setIsLoading] = useState(true);
  const refresh = useRefreshToken();
  const { auth } = useAuth();

  useEffect(() => {
    async function verifyRefreshToken() {
      setIsLoading(true);
      try {
        await refresh();
      } catch (err: unknown) {
        const error = err as { response?: { status: number } };
        if (error?.response?.status !== 401) {
          console.error(err);
        }
      } finally {
        setIsLoading(false);
      }
    }

    if (!auth?.accessToken) {
      verifyRefreshToken();
    } else {
      setIsLoading(false);
    }
  }, [auth, refresh]);

  return isLoading ? <IsLoading /> : <Outlet />;
}
